'use client';

import { useEffect } from 'react';
import { Stage, stageFromString } from '@eventbrite/webapp-constants';
import { getEBWidgetsScriptUrl } from '@/src/listings/utils/widgetUtils';
import { getWindowObject } from '@eventbrite/legacy-infra.feature-detection';

interface EBWidgetsScriptProps {
  hostname?: string;
  onScriptLoad?: () => void;
  stage?: string;
}

export const EBWidgetsScript: React.FC<EBWidgetsScriptProps> = ({ hostname, onScriptLoad, stage = Stage.TEST }) => {
  useEffect(() => {
    const scriptId = 'eb-widgets-script';

    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      if (onScriptLoad && typeof window !== 'undefined' && getWindowObject('EBWidgets')) {
        onScriptLoad();
      }
      return;
    }

    const resolvedHostname = hostname || (typeof window !== 'undefined' ? window.location.hostname : '');
    const scriptUrl = getEBWidgetsScriptUrl(stageFromString(stage), resolvedHostname);

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = scriptUrl;
    script.async = false;

    script.onload = () => {
      if (onScriptLoad) {
        onScriptLoad();
      }
    };

    script.onerror = () => {
      console.error('Failed to load EB Widgets script');
    };

    document.body.appendChild(script);
  }, [hostname, onScriptLoad, stage]);

  return null;
};
